import { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { handleUnknownErrors, intlShape } from "lcm-iot-commons";
import { MenuItem } from "react-bootstrap";
import ItemMenu from "lcm-iot-commons/client/lib/components/ItemMenu";

import ConfirmationModal from "lcm-iot-commons/client/lib/components/ConfirmationModal";
import { technicalUserShape } from "../../shapes/technicalUsersShape";
import { accessRightsShape } from "../../shapes/accessRightsShape";
import TechnicalUserModal from "../TechnicalUsers/TechnicalUserModal";
import { resetEdgeDeviceTechnicalUserPassword } from "../../api";

type OwnProps = {
  edgeDevice: {
    id?: number;
  };
  technicalUser?: technicalUserShape;
  accessRights?: accessRightsShape;
  intl?: intlShape;
};

type State = $TSFixMe;

const defaultProps: Partial<OwnProps> = {
  technicalUser: undefined,
  accessRights: undefined,
  intl: undefined,
};

type Props = OwnProps & typeof defaultProps;

class EdgeDeviceDetailsTechnicalUserItem extends Component<Props, State> {
  // eslint-disable-next-line react/static-property-placement
  static readonly defaultProps = defaultProps;

  constructor(props: Props) {
    super(props);
    /* istanbul ignore next */
    this.handleOnResetClick = this.handleOnResetClick.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.onResetEdgeDeviceTechnicalUserPasswordConfirmationModal =
      this.onResetEdgeDeviceTechnicalUserPasswordConfirmationModal.bind(this);
    this.state = {
      isResetting: false,
      showModal: false,
      newPassword: null,
    };
  }

  onCloseModal() {
    this.resetActionsState();
  }

  async onResetEdgeDeviceTechnicalUserPasswordConfirmationModal() {
    const { intl, edgeDevice } = this.props;
    const { isResetting } = this.state;
    this.resetActionsState();
    /* istanbul ignore next */
    if (isResetting) {
      return resetEdgeDeviceTechnicalUserPassword(edgeDevice.id)
        .then((newPassword) => {
          this.setState({
            showModal: true,
            newPassword: (newPassword as $TSFixMe).password,
          });
        })
        .catch((apiErrors) => {
          handleUnknownErrors(
            apiErrors,
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            intl.formatMessage({ id: "api.error.unknown" }),
          );
        });
    }
    /* istanbul ignore next */
    return null;
  }

  resetActionsState() {
    this.setState({ isResetting: false, showModal: false });
  }

  handleOnResetClick() {
    this.setState({ isResetting: true });
  }

  render() {
    const { technicalUser, accessRights, intl } = this.props;
    const { newPassword, showModal, isResetting } = this.state;
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    const canUpdateAndDelete = accessRights.canUpdate;
    const technicalUserModal =
      showModal && newPassword ? (
        <TechnicalUserModal
          // @ts-expect-error TS(2322) FIXME: Type '{ id: string; show: any; titleText: string; ... Remove this comment to see the full error message
          id="modal-dialog"
          show={showModal}
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          titleText={intl.formatMessage({
            id: "technical_user_modal.reset_password.modal_title",
          })}
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          contextBodyText={intl.formatMessage({
            id: "technical_user_modal.reset_password.modal_message",
          })}
          onClose={this.onCloseModal}
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          username={technicalUser.email}
          password={newPassword}
        />
      ) : null;
    const resetConfirmationModal = isResetting ? (
      <ConfirmationModal
        id="reset-confirmation-modal"
        show
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        titleText={intl.formatMessage({
          id: "password_reset.actions.modal_title",
        })}
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        messageText={intl.formatMessage(
          { id: "password_reset.actions.modal_message" },
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          { technicalUser: technicalUser.email },
        )}
        onConfirm={this.onResetEdgeDeviceTechnicalUserPasswordConfirmationModal}
        onClose={this.onCloseModal}
      />
    ) : null;

    return (
      <li className="list-item">
        <div className="list-item-image">
          <span className="icon lcm-iot-icon-user" />
        </div>
        <div className="list-item-content">
          {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
          <div className="list-item-header">{technicalUser.email}</div>
          <div className="list-item-details">
            <FormattedMessage id="label.technical_user_id" />
            {": "}
            {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
            {technicalUser.id}
          </div>
        </div>
        {
          /* istanbul ignore next */
          canUpdateAndDelete ? (
            <div className="list-item-actions">
              <ItemMenu>
                <MenuItem id="item-reset" onSelect={this.handleOnResetClick}>
                  <FormattedMessage id="button.reset_password" />
                </MenuItem>
              </ItemMenu>
            </div>
          ) : null
        }
        {technicalUserModal}
        {resetConfirmationModal}
      </li>
    );
  }
}

// @ts-expect-error TS(2769) FIXME: No overload matches this call.
export default injectIntl(EdgeDeviceDetailsTechnicalUserItem);
